import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/global-error.jsx");
